module.exports = __webpack_public_path__ + "bef4f33817208e33b5f688345bda14dc.pdf";